import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    flex: 1,
    padding: theme.spacing(0, 2.5, 2.5),
    height: (props) => (props.fullHeight ? "100%" : "auto"),
    minHeight: 0,
  },

  contentWrapper: {
    height: (props) => (props.fullHeight ? "100%" : "auto"),
    minHeight: 0,
    overflowY: (props) => props.scrollY || "hidden",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
}));

const MainContainer = ({ children, scrollY = "hidden", fullHeight = true }) => {
  const classes = useStyles({ scrollY, fullHeight });

  return (
    <Container className={classes.mainContainer} maxWidth={false}>
      <div className={classes.contentWrapper}>{children}</div>
    </Container>
  );
};

export default MainContainer;
